import { render } from "./Diff.vue?vue&type=template&id=46e3fb05&scoped=true"
import script from "./Diff.vue?vue&type=script&lang=js"
export * from "./Diff.vue?vue&type=script&lang=js"

import "./Diff.vue?vue&type=style&index=0&id=46e3fb05&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46e3fb05"]])

export default __exports__